import {
  FilterOptionKeys,
  GoalGroupBy,
  GoalSortingMode,
  GroupByMode,
} from '@griply/types';

export const goalListGroupOptions = [
  GroupByMode.None,
  GroupByMode.LifeArea,
  GroupByMode.Deadline,
] as const satisfies GoalGroupBy[];

export const goalListSortOptions = [
  GoalSortingMode.Custom,
  GoalSortingMode.StartDate,
  GoalSortingMode.Deadline,
  GoalSortingMode.Name,
  GoalSortingMode.Progress,
  GoalSortingMode.Impact,
  GoalSortingMode.Tasks,
  GoalSortingMode.LifeArea,
] as const satisfies GoalSortingMode[];

export const goalListFilters = [
  FilterOptionKeys.LifeArea,
  FilterOptionKeys.Date,
  FilterOptionKeys.Deadline,
  FilterOptionKeys.GoalActive,
  FilterOptionKeys.GoalImpact,
] as const satisfies FilterOptionKeys[];

export const goalNoImpactFilterValue = 'none';

export type GoalListOptions = {
  // Set on a single-life-area goal list: every goal already shares the life
  // area, so the life-area sort / group / filter option is dropped.
  hideLifeArea?: boolean;
};

export const getGoalListSortOptions = ({
  hideLifeArea,
}: GoalListOptions): GoalSortingMode[] =>
  hideLifeArea
    ? goalListSortOptions.filter((mode) => mode !== GoalSortingMode.LifeArea)
    : [...goalListSortOptions];

export const getGoalListGroupOptions = ({
  hideLifeArea,
}: GoalListOptions): GoalGroupBy[] =>
  hideLifeArea
    ? goalListGroupOptions.filter((mode) => mode !== GroupByMode.LifeArea)
    : [...goalListGroupOptions];

export type GoalListFilterKey = (typeof goalListFilters)[number];

export const getGoalListFilters = ({
  hideLifeArea,
}: GoalListOptions): GoalListFilterKey[] =>
  hideLifeArea
    ? goalListFilters.filter((key) => key !== FilterOptionKeys.LifeArea)
    : [...goalListFilters];
